"use client";

import { Tabs, type TabProperties } from "@jetblue/kit/tabs";
import {
  Children,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";

type InfoTabsAreaClientProperties = {
  children?: ReactNode;
  tabsData: { label: string; id: string }[];
  theme?: "light" | "dark" | undefined;
};

export const InfoTabsAreaClient = ({
  children,
  tabsData,
}: InfoTabsAreaClientProperties) => {
  const items = Children.toArray(children ?? []);

  const tabs: TabProperties[] = items
    .map((item, index) => {
      if (!isValidElement<ReactElement<{ children?: ReactNode }>>(item)) {
        return null;
      }

      if (!tabsData[index]) {
        return null;
      }

      const id = tabsData[index].id;
      const label = tabsData[index].label;
      const panel = item;

      return { id, label, panel } as TabProperties;
    })
    .filter(Boolean) as TabProperties[];

  if (tabs.length === 0) {
    return null;
  }

  return <Tabs className="[*+&]:mt-4 md:[*+&]:mt-6" tabs={tabs} />;
};
